import React, { useState } from "react";
import { Row, Col } from "antd";
import logo from "../assets/images/footerLogo.png"; // Ensure the logo path is correct
import QRCodeModal from "./QRCodeModal";

const Footer = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };
  return (
    <footer className="bg-[#f0f0f0] pt-10  pb-6 lg:px-14 lg:py-10">
      <div className="max-screen mx-auto  sm:px-6  flex-col">
        <Row gutter={[32, 32]} justify="space-between">
          <Col xs={24} sm={12} lg={6}>
            <div className="space-y-4">
              <img src={logo} alt="RevAiv Logo" className="md:mx-0 mb-2" />
              <button
                onClick={showModal}
                className="bg-[#1A3333] text-white font-medium py-2 px-4 rounded"
              >
                Download the App
              </button>
              <div className="flex md:justify-start gap-4 pt-4">
                <a
                  href="https://www.facebook.com/revaivapp?mibextid=wwXIfr"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="37"
                    viewBox="0 0 36 37"
                    fill="none"
                  >
                    <path
                      d="M30.7096 33.7085C22.4747 33.7085 14.2338 33.7085 5.99888 33.7085C5.59703 33.6005 5.19518 33.4926 4.82932 33.2767C3.82169 32.7009 3.24591 31.8252 3 30.7096C3 22.4747 3 14.2338 3 5.99888C3.10796 5.59703 3.22192 5.19518 3.43184 4.82932C4.00762 3.82169 4.88329 3.24591 5.99888 3C14.2338 3 22.4747 3 30.7096 3C31.1115 3.10796 31.5133 3.21592 31.8792 3.43184C32.8808 4.00762 33.4626 4.88329 33.7085 5.99888C33.7085 14.2338 33.7085 22.4747 33.7085 30.7096C33.6005 31.1115 33.4866 31.5133 33.2767 31.8792C32.7009 32.8868 31.8252 33.4626 30.7096 33.7085ZM5.42309 18.3243C5.42309 22.1628 5.42309 26.0014 5.42309 29.84C5.42309 30.8236 5.87892 31.2854 6.84456 31.2854C10.941 31.2854 15.0435 31.2854 19.14 31.2854C19.5238 31.2854 19.5298 31.2794 19.5298 30.9016C19.5298 27.9147 19.5298 24.9218 19.5358 21.9349C19.5358 21.647 19.4518 21.5451 19.158 21.5511C18.2103 21.569 17.2567 21.5451 16.309 21.5631C15.9971 21.569 15.9192 21.4611 15.9252 21.1672C15.9432 20.1656 15.9432 19.1699 15.9252 18.1683C15.9192 17.8564 16.0331 17.7785 16.321 17.7845C17.2507 17.8025 18.1803 17.7905 19.11 17.7905C19.5298 17.7905 19.5178 17.7905 19.5298 17.3706C19.5538 16.363 19.4578 15.3494 19.5958 14.3478C19.8957 12.0686 21.9289 10.0474 24.2021 9.75347C25.2397 9.62152 26.2773 9.71748 27.3149 9.69349C27.5608 9.6875 27.5488 9.84944 27.5488 10.0174C27.5488 11.055 27.5428 12.0986 27.5548 13.1362C27.5548 13.3821 27.4708 13.4661 27.2249 13.4601C26.5652 13.4481 25.9054 13.4481 25.2457 13.4601C24.0221 13.4721 23.3084 14.1798 23.2964 15.4034C23.2904 16.0751 23.3084 16.7409 23.2904 17.4126C23.2844 17.7005 23.3744 17.7965 23.6683 17.7965C24.8798 17.7845 26.0854 17.7965 27.2969 17.7905C27.5548 17.7905 27.6268 17.8684 27.5788 18.1263C27.3989 19.146 27.2309 20.1716 27.075 21.1972C27.033 21.4671 26.931 21.5631 26.6491 21.5631C25.6415 21.5511 24.6279 21.563 23.6203 21.5511C23.3744 21.5511 23.2904 21.641 23.2904 21.8869C23.2964 24.9038 23.2964 27.9267 23.2904 30.9435C23.2904 31.2014 23.3744 31.2974 23.6383 31.2914C24.6579 31.2794 25.6775 31.2854 26.6971 31.2854C27.7767 31.2854 28.8563 31.2914 29.9359 31.2854C30.7996 31.2794 31.2674 30.8056 31.2854 29.9479C31.2854 29.8759 31.2854 29.81 31.2854 29.738C31.2854 22.1508 31.2854 14.5637 31.2854 6.97651C31.2854 6.87455 31.2914 6.77859 31.2854 6.67662C31.2434 5.90891 30.7996 5.46508 30.0259 5.42309C29.9539 5.4171 29.8879 5.42309 29.816 5.42309C22.1688 5.42309 14.5217 5.42309 6.87455 5.42309C6.7366 5.42309 6.59265 5.42909 6.45471 5.45308C5.86693 5.55504 5.55504 5.86693 5.45308 6.44871C5.42309 6.61665 5.4171 6.78458 5.4171 6.95252C5.42309 10.7491 5.42309 14.5337 5.42309 18.3243Z"
                      fill="#27696D"
                    />
                  </svg>
                </a>
                <a href="https://www.instagram.com/revaiv.app/" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="37"
                    viewBox="0 0 35 37"
                    fill="none"
                  >
                    <path
                      d="M23.8722 33.7085C20.2315 33.7085 16.5969 33.7085 12.9563 33.7085C12.8363 33.6965 12.7224 33.6725 12.6024 33.6725C11.7447 33.6605 10.887 33.5885 10.0414 33.4266C7.73823 32.9828 5.86693 31.8672 4.56541 29.8819C3.5398 28.3105 3.19793 26.5412 3.10196 24.6999C3.006 22.8766 3.04198 21.0472 3.02999 19.2179C3.02999 19.05 3.012 18.8821 3 18.7141C3 18.4742 3 18.2343 3 17.9944C3.012 17.8145 3.02999 17.6345 3.02999 17.4606C3.04798 15.2234 2.96401 12.9863 3.22192 10.7611C3.40785 9.18368 3.89367 7.70224 4.8593 6.41272C6.50269 4.23554 8.77584 3.31788 11.4089 3.10196C11.9247 3.05998 12.4405 3.03599 12.9563 3C16.5729 3 20.1956 3 23.8122 3C23.9322 3.012 24.0461 3.03599 24.1661 3.03599C25.0357 3.04798 25.9054 3.11396 26.7571 3.28189C30.1398 3.96564 32.371 5.92091 33.3186 9.27365C33.5346 10.0474 33.6185 10.8391 33.7085 11.6308C33.7085 16.0511 33.7085 20.4655 33.7085 24.8858C33.6365 25.4676 33.6005 26.0554 33.4866 26.6372C33.1207 28.5684 32.287 30.2418 30.7756 31.5433C29.2282 32.8808 27.3869 33.4446 25.3896 33.6005C24.8858 33.6485 24.382 33.6725 23.8722 33.7085ZM18.4082 30.9195C20.1956 30.9495 21.9889 30.8896 23.7762 30.8536C24.6219 30.8356 25.4736 30.7996 26.3073 30.6257C28.5264 30.1638 29.9839 28.8863 30.5837 26.6671C30.8656 25.6235 30.9016 24.5499 30.9135 23.4883C30.9495 20.9813 30.9495 18.4682 30.9435 15.9611C30.9375 14.2638 30.9735 12.5604 30.7516 10.8751C30.4097 8.30801 28.8743 6.65263 26.3433 6.11883C25.1617 5.86693 23.9562 5.86693 22.7626 5.85493C19.8717 5.82494 16.9868 5.82494 14.0958 5.85493C12.9623 5.86693 11.8167 5.89092 10.6891 6.07685C8.29602 6.4787 6.71861 7.97214 6.18481 10.3353C5.9449 11.3969 5.92091 12.4765 5.90891 13.556C5.87892 16.7648 5.88492 19.9736 5.90891 23.1824C5.91491 24.1901 5.9449 25.1977 6.14282 26.1933C6.58666 28.4545 7.87018 29.9419 10.1313 30.5417C11.097 30.7996 12.0866 30.8416 13.0762 30.8596C14.8516 30.8956 16.6269 30.9495 18.4082 30.9195Z"
                      fill="#27696D"
                    />
                    <path
                      d="M18.3903 26.2891C14.0359 26.2831 10.4792 22.7025 10.4792 18.3421C10.4852 13.9937 14.0599 10.4191 18.4143 10.4251C22.7806 10.4311 26.3553 14.0237 26.3373 18.3841C26.3253 22.7384 22.7507 26.2951 18.3903 26.2891ZM18.4023 23.4342C21.2092 23.4342 23.4884 21.173 23.4944 18.3721C23.5004 15.5651 21.2272 13.28 18.4383 13.274C15.6133 13.268 13.3402 15.5351 13.3402 18.3541C13.3342 21.161 15.5953 23.4342 18.4023 23.4342Z"
                      fill="#27696D"
                    />
                    <path
                      d="M26.6011 12.0207C25.5575 12.0207 24.7478 11.205 24.7478 10.1554C24.7478 9.12378 25.5755 8.28409 26.6071 8.2721C27.6147 8.2601 28.4844 9.12977 28.4964 10.1434C28.5024 11.175 27.6507 12.0207 26.6011 12.0207Z"
                      fill="#27696D"
                    />
                  </svg>
                </a>

                <a
                  href="https://www.linkedin.com/company/revaiv/"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="37"
                    viewBox="0 0 35 37"
                    fill="none"
                  >
                    <path
                      d="M30.7096 33.7085C22.4747 33.7085 14.2338 33.7085 5.99888 33.7085C5.57304 33.5945 5.15919 33.4746 4.77534 33.2467C3.8037 32.6709 3.23991 31.8012 3 30.7096C3 22.4747 3 14.2338 3 5.99888C3.10796 5.58503 3.22791 5.17719 3.44383 4.79933C4.01962 3.8097 4.89529 3.24591 5.99888 3C14.2338 3 22.4747 3 30.7096 3C31.1055 3.10796 31.4953 3.20992 31.8552 3.41385C32.8748 3.98963 33.4566 4.8713 33.7085 5.99888C33.7085 14.2338 33.7085 22.4747 33.7085 30.7096C33.6005 31.1115 33.4866 31.5133 33.2767 31.8792C32.7009 32.8868 31.8252 33.4626 30.7096 33.7085ZM18.3842 5.42309C14.5577 5.42309 10.7311 5.42309 6.89854 5.42309C5.86093 5.42309 5.4171 5.86093 5.4171 6.89854C5.4171 14.5337 5.4171 22.1688 5.4171 29.804C5.4171 30.8416 5.85493 31.2854 6.89254 31.2854C14.5277 31.2854 22.1628 31.2854 29.798 31.2854C30.8356 31.2854 31.2794 30.8416 31.2794 29.81C31.2794 22.1748 31.2794 14.5397 31.2794 6.90454C31.2794 5.86693 30.8416 5.42309 29.804 5.42309C26.0014 5.42309 22.1928 5.42309 18.3842 5.42309Z"
                      fill="#27696D"
                    />
                    <path
                      d="M19.3379 16.507C19.5898 16.1771 19.7877 15.9192 20.0337 15.6973C20.8074 15.0076 21.731 14.6477 22.7506 14.5637C23.4704 14.5037 24.1901 14.5397 24.8978 14.6897C26.7151 15.0855 27.6988 16.2671 28.0886 18.0244C28.2446 18.7502 28.3345 19.4819 28.3345 20.2256C28.3405 22.8166 28.3345 25.4017 28.3345 27.9927C28.3345 28.3825 28.3345 28.3885 27.9327 28.3885C26.8051 28.3885 25.6715 28.3885 24.544 28.3885C24.1541 28.3885 24.1541 28.3885 24.1541 27.9807C24.1541 25.9295 24.1601 23.8842 24.1481 21.833C24.1481 21.1852 24.1361 20.5315 23.9922 19.8957C23.7343 18.7921 23.1825 18.2643 22.1149 18.2044C21.0293 18.1444 20.1536 18.5102 19.7038 19.5539C19.4039 20.2376 19.3559 20.9693 19.3499 21.701C19.3379 23.7883 19.3439 25.8815 19.3439 27.9687C19.3439 28.3885 19.3439 28.3885 18.9361 28.3885C17.8145 28.3885 16.6989 28.3825 15.5773 28.3945C15.3074 28.3945 15.2115 28.3166 15.2115 28.0407C15.2175 23.7403 15.2175 19.4459 15.2115 15.1455C15.2115 14.8756 15.2954 14.7796 15.5713 14.7856C16.7109 14.7976 17.8505 14.7976 18.99 14.7856C19.2659 14.7796 19.3559 14.8756 19.3499 15.1455C19.3259 15.5713 19.3379 15.9972 19.3379 16.507Z"
                      fill="#27696D"
                    />
                    <path
                      d="M8.37401 21.5631C8.37401 19.4459 8.37401 17.3287 8.37401 15.2055C8.37401 14.7916 8.37401 14.7916 8.78785 14.7916C9.94542 14.7916 11.109 14.7976 12.2666 14.7856C12.5424 14.7856 12.6264 14.8756 12.6264 15.1455C12.6204 19.4399 12.6204 23.7403 12.6264 28.0347C12.6264 28.3046 12.5424 28.3945 12.2666 28.3945C11.085 28.3826 9.90943 28.3826 8.72788 28.3945C8.45198 28.3945 8.36801 28.3046 8.36801 28.0347C8.38001 25.8815 8.37401 23.7223 8.37401 21.5631Z"
                      fill="#27696D"
                    />
                    <path
                      d="M10.5571 8.01416C11.9546 8.01416 13.0401 9.10575 13.0401 10.5032C13.0401 11.8947 11.9426 12.9803 10.5391 12.9743C9.1656 12.9743 8.07401 11.8767 8.07401 10.4972C8.07401 9.10575 9.1596 8.01416 10.5571 8.01416Z"
                      fill="#27696D"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </Col>
          <Col xs={24} sm={12} lg={18}>
            <Row gutter={[32, 32]} justify="end">
              <Col xs={12} sm={12} lg={6}>
                <div>
                  <h4 className="font-semibold text-[#27696D] text-lg mb-2">
                    About us
                  </h4>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="43"
                    height="4"
                    viewBox="0 0 43 4"
                    fill="none"
                  >
                    <path
                      d="M2 2H41"
                      stroke="#27696D"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </svg>
                  <ul className="mt-4 space-y-2">
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        Mission
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        Contact Us
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        Press Release
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={12} lg={6}>
                <div>
                  <h4 className="font-semibold text-[#27696D] text-lg mb-2">
                    Support
                  </h4>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="43"
                    height="4"
                    viewBox="0 0 43 4"
                    fill="none"
                  >
                    <path
                      d="M2 2H41"
                      stroke="#27696D"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </svg>
                  <ul className="mt-4 space-y-2">
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        FAQs
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <div>
                  <h4 className="font-semibold text-[#27696D] text-lg mb-2">
                    More
                  </h4>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="43"
                    height="4"
                    viewBox="0 0 43 4"
                    fill="none"
                  >
                    <path
                      d="M2 2H41"
                      stroke="#27696D"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </svg>
                  <ul className="mt-4 space-y-2">
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-[#27696D] hover:text-gray-900"
                      >
                        For Business
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="text-left pt-5 text-[#27696D] text-sm">
          © 2024 RevAiv Health LLC-FZ | All Rights Reserved.
        </div>
      </div>

      <QRCodeModal visible={isModalVisible} setVisible={setIsModalVisible} />
    </footer>
  );
};

export default Footer;
